module.exports = __webpack_public_path__ + "static/media/sample.0f7e5b73.png";